import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useToastStore } from '../stores/useToastStore';

export default function ToastContainer() {
    
    const toasts = useToastStore(state => state.toasts);

    const removeToast = useToastStore(state => state.removeToast);

    return (
        <>
            {toasts.map((toast, index) => (

                <Snackbar
                    key={toast.id}
                    open
                    autoHideDuration={toast.duration}
                    onClose={() =>
                        removeToast(toast.id)
                    }
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                    }}
                    sx={{
                        mt: `${index * 70}px`
                    }}
                >
                    <Alert
                        severity={toast.type}
                        variant="filled"
                        onClose={() =>
                            removeToast(toast.id)
                        }
                        sx={{
                            minWidth: 320
                        }}
                    >
                        {toast.message}
                    </Alert>
                </Snackbar>

            ))}
        </>
    );
}